<template>
  <div class="homeContent">
    <div class="col s12">
      <div class="card col s12 black white-text">
        <div class="open text-center">
          <div>
            <span style="font-weight:bolder;font-size:18px;"> We are open</span>
          </div>
          <div>
            <span>
              <i class="far fa-calendar-alt"></i> Monday - Friday<br />
              <i class="far fa-clock"></i> 07:30am ~ 06:00pm
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="video-container">
      <div class="content">
        <video
          oncontextmenu="return false;"
          controls
          loop="loop"
          autoplay="autoplay"
          muted
          controlslist="nodownload"
          frameborder="0"
          allowfullscreen
          width="853"
          height="480"
        >
          <source src="@/assets/AD_Video_full.mp4" type="video/mp4" />
        </video>
      </div>
      <div class="vid-txt">
        <span> <i>Discounts</i> available for first 20 customers. </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/*==================Video================*/
.video-container {
  height: 100%;
  padding-bottom: 6.25%;
}

.content {
  padding: 20px 0;
  cursor: pointer;
  background-color: #c2cad0;
}

video {
  display: block;
  margin: 0 auto;
}

.vid-txt {
  text-align: center;
  background-color: #c2cad0;
}

.vid-txt span {
  text-decoration: none;
  font-weight: 700;
  font-size: 3.5rem;
  animation: word 1.5s infinite;
  font-style: oblique;
  transition: ease-out;
  position: relative;
}

@keyframes word {
  0% {
    color: red;
  }

  25% {
    color: green;
  }

  50% {
    color: palevioletred;
  }

  75% {
    color: indigo;
  }

  100% {
    color: orange;
  }
}

@media screen and (max-width: 786px) {
  video {
    display: block;
    margin: auto;
    width: 95%;
    height: auto;
  }
}
</style>
